import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'vipViewsColor',
})
export class ViewsColorPipe implements PipeTransform {
	constructor() {}
	transform(views: number): string {
		if (views <= 9999) {
			return 'grey';
		} else if (views > 9999 && views <= 19999) {
			return 'purple';
		} else {
			return 'accent';
		}
	}
}
